import { Textarea } from "@/components/ui/textarea"

export function TextareaPreviewRoute(): JSX.Element {
  return (
    <div className="mx-auto max-w-4xl px-8.5 py-11">
      <header className="mb-8">
        <div className="font-id text-eyebrow uppercase tracking-[0.16em] text-text-3">
          Primitive
        </div>
        <h1 className="mt-1 text-display text-text">Textarea</h1>
      </header>

      <Section title="Default">
        <div className="w-96">
          <Textarea defaultValue="A default value that autosizes as you type." />
        </div>
      </Section>

      <Section title="Disabled">
        <div className="w-96">
          <Textarea disabled defaultValue="Disabled content — not editable." />
        </div>
      </Section>

      <Section title="With placeholder">
        <div className="w-96">
          <Textarea placeholder="Why this finding is a violation…" />
        </div>
      </Section>
    </div>
  )
}

function Section({ title, children }: { title: string; children: React.ReactNode }): JSX.Element {
  return (
    <section className="mb-8">
      <h2 className="mb-3.5 font-id text-caption uppercase tracking-[0.16em] text-text-3">
        {title}
      </h2>
      <div className="flex flex-wrap items-center gap-3.5">{children}</div>
    </section>
  )
}
